// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-admin-section-nav {
  display: inline-flex;
  gap: 6px;
  margin: 0 0 22px;
  padding: 5px;
  border: 1px solid #dce2d8;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
}

.canvas-admin-section-nav a {
  padding: 9px 16px;
  border-radius: 999px;
  color: #6b7368;
  font-size: 12px;
  font-weight: 750;
  text-decoration: none;
}

.canvas-admin-section-nav a.is-active {
  background: #1d251b;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminSectionNav/AdminSectionNav.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".canvas-admin-section-nav {\n  display: inline-flex;\n  gap: 6px;\n  margin: 0 0 22px;\n  padding: 5px;\n  border: 1px solid #dce2d8;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.canvas-admin-section-nav a {\n  padding: 9px 16px;\n  border-radius: 999px;\n  color: #6b7368;\n  font-size: 12px;\n  font-weight: 750;\n  text-decoration: none;\n}\n\n.canvas-admin-section-nav a.is-active {\n  background: #1d251b;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
